import { render, staticRenderFns } from "./ProductFormBundles.vue?vue&type=template&id=3134a966&"
import script from "./ProductFormBundles.vue?vue&type=script&lang=js&"
export * from "./ProductFormBundles.vue?vue&type=script&lang=js&"
import style0 from "./ProductFormBundles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VForm,VIcon})
